import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  initialValues,
  validationSchema,
} from "../../componentes/Ingresar/Ingresar.Form";
import { useFormik } from "formik";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import { Grid, Header, Image, Modal, Menu } from "semantic-ui-react";
import TextField from "@mui/material/TextField";
import {
  ingresar,
  email,
  contrasena,
  olvidaste_tu_contrasena,
  crear_cuenta,
  politica_de_privacidad,
  condiciones_del_servicio,
  cerrar,
  datos_incorrectos,
  cambiar_idioma,
} from "../../utils/traductor";
import { apigoogleRecaptchaV3 } from "../../api";
import { apiTexto } from "../../api/texto";
import { apiUsuario } from "../../api/usuario";
// import { apiPing } from "../../api/ping";
import Swal from "sweetalert2";
import { estiloBotones } from "../../estilos";
import { estiloColores } from "../../estilos/colores";
import { BarraSuperior } from "../../estilos/barraSuperior";
import { SinConexionAInternet } from "./SinConexionAInternet";
import {
  ENTORNO,
  HabilitarGoogleRecaptcha,
  HabilitarLoginAutomatico,
} from "../../utils/constantes";
import {
  setIdioma,
  getIdioma,
  setmenuAbajoSeleccionado,
  getrole,
  getemail,
  getpassword,
} from "../../utils/variablesLocales";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import ReactRecaptcha3 from "react-google-recaptcha3";
import Backdrop from "@mui/material/Backdrop";
import animacion from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

const apigooglerecaptchav3 =
  HabilitarGoogleRecaptcha === true ? new apigoogleRecaptchaV3() : null;

const apiusuario = new apiUsuario();
const apitexto = new apiTexto();

function exampleReducerPP(state, action) {
  switch (action.type) {
    case "OPEN_MODAL":
      return { openPP: true, dimmerPP: action.dimmer };
    case "CLOSE_MODAL":
      return { openPP: false };
    default:
      throw new Error();
  }
}

function exampleReducerCS(state, action) {
  switch (action.type) {
    case "OPEN_MODAL":
      return { openCS: true, dimmerCS: action.dimmer };
    case "CLOSE_MODAL":
      return { openCS: false };
    default:
      throw new Error();
  }
}

export function Ingresar() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [statePP, dispatchPP] = React.useReducer(exampleReducerPP, {
    open: false,
    dimmer: undefined,
  });
  const { openPP, dimmerPP } = statePP;

  const [stateCS, dispatchCS] = React.useReducer(exampleReducerCS, {
    open: false,
    dimmer: undefined,
  });
  const { openCS, dimmerCS } = stateCS;

  const ValidarTokenRecaptcha = async (
    tokenGoogleRecaptchaV3,
    ipPublicaValor,
    email,
    password,
    navigateToInicioPasajero,
    navigateToInicioConductor,
    navigateToInicioAdministrador
  ) => {
    if (HabilitarGoogleRecaptcha) {
      const respuestaVerificacionRecaptcha =
        await apigooglerecaptchav3.verificar(
          tokenGoogleRecaptchaV3,
          ipPublicaValor
        );

      if (respuestaVerificacionRecaptcha === true) {
        IngresarConfirmar(
          email,
          password,
          navigateToInicioPasajero,
          navigateToInicioConductor,
          navigateToInicioAdministrador
        );
      } else {
      }
    } else {
      IngresarConfirmar(
        email,
        password,
        navigateToInicioPasajero,
        navigateToInicioConductor,
        navigateToInicioAdministrador
      );
    }
  };

  const IngresarConfirmar = async (
    email,
    password,
    navigateToInicioPasajero,
    navigateToInicioConductor,
    navigateToInicioAdministrador
  ) => {
    email = email.toLowerCase();

    const response = await apiusuario.Ingresar(email, password, getIdioma());

    if (response === "Ok") {
      // if (getrole() === "Pasajero" && isMobile === false) {
      //   Swal.fire({
      //     title: "Error!",
      //     text: dispositivo_movil_no_detectado,
      //     icon: "error",
      //     confirmButtonText: "Ok",
      //     confirmButtonColor: estiloColores.Gris,
      //   });
      // }
      // if (getrole() === "Conductor" && isMobile === false) {
      //   Swal.fire({
      //     title: "Error!",
      //     text: dispositivo_movil_no_detectado,
      //     icon: "error",
      //     confirmButtonText: "Ok",
      //     confirmButtonColor: estiloColores.Gris,
      //   });
      // }

      if (getrole() === "Pasajero" /*&& isMobile === true*/) {
        //destruir el recaptcha
        if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

        navigateToInicioPasajero();
      }
      if (getrole() === "Conductor" /*&& isMobile === true*/) {
        //destruir el recaptcha
        if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

        navigateToInicioConductor();
      }
      if (getrole() === "Administrador") {
        //destruir el recaptcha
        if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

        navigateToInicioAdministrador();
      }
    } else {
      let MensajeError = "";
      if (response === "" || response === undefined) {
        MensajeError = datos_incorrectos;
      } else {
        MensajeError = response;
      }
      Swal.fire({
        title: "Error!",
        text: MensajeError,
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: estiloColores.Gris,
      });
    }
  };

  const navigate = useNavigate();

  const navigateToInicioPasajero = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const navigateToInicioConductor = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const navigateToInicioAdministrador = () => {
    setIdioma("Español");
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  const navigateToCambiarClave = () => {
    navigate(ENTORNO.URL_APLICACION + "/OlvidoSuClave");
  };

  const navigateToSeleccionarIdioma = () => {
    navigate(ENTORNO.URL_APLICACION + "/SeleccionarIdioma");
  };

  const navigateToCrearCuenta = () => {
    navigate(ENTORNO.URL_APLICACION + "/CrearCuenta");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (getIdioma() === null) {
          setIdioma("Español");
        }

        //validacion google recaptcha v3
        //1. calculo ip publica
        const ipPublica = require("react-public-ip");
        const ipPublicaValor = (await ipPublica.v4()) || "";

        //2. obtengo token google recaptcha
        if (HabilitarGoogleRecaptcha) {
          ReactRecaptcha3.getToken().then(
            (tokenGoogleRecaptchaV3) => {
              ValidarTokenRecaptcha(
                tokenGoogleRecaptchaV3,
                ipPublicaValor,
                formik.values.email,
                formik.values.password,
                navigateToInicioPasajero,
                navigateToInicioConductor,
                navigateToInicioAdministrador
              );
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          IngresarConfirmar(
            formik.values.email,
            formik.values.password,
            navigateToInicioPasajero,
            navigateToInicioConductor,
            navigateToInicioAdministrador
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  const [PoliticaPrivacidad, setPoliticaPrivacidad] = useState(null);
  const [CondicionesDeUso, setCondicionesDeUso] = useState(null);

  const [FalloLoginAutomatico, setFalloLoginAutomatico] = useState(false);

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        //obtengo version del backend
        // const respuestaapiPing = await apiping.obtenerVersionBackEnd();
        // setVersionBackend(respuestaapiPing.Version);

        //en caso que existan valores correctos de login en local storage, ingresa automaticamente
        if (HabilitarLoginAutomatico === true) {
          if (getIdioma() === null) {
            setIdioma("Español");
          }

          let Idioma = getIdioma();
          let email = getemail();
          let password = getpassword();

          if (
            email !== "null" &&
            password !== "null" &&
            email !== "" &&
            password !== "" &&
            email !== undefined &&
            password !== undefined
          ) {
            //login automatico
            const response = await apiusuario.IngresarConPasswordEncriptado(
              email,
              password,
              Idioma
            );

            if (response === "Ok") {
              setFalloLoginAutomatico(false);

              //ingresar a inicio
              if (getrole() === "Pasajero" /*&& isMobile === true*/) {
                //destruir el recaptcha
                if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

                navigateToInicioPasajero();
              }

              if (getrole() === "Conductor" /*&& isMobile === true*/) {
                //destruir el recaptcha
                if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

                navigateToInicioConductor();
              }

              if (getrole() === "Administrador") {
                //destruir el recaptcha
                if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

                navigateToInicioAdministrador();
              }
            } else {
              //no hay login automatico
              setFalloLoginAutomatico(true);
            }
          } else {
            //no hay login automatico
            setFalloLoginAutomatico(true);
          }
        }

        ////////////////////////////////////////////////////////

        const responsePoliticaPrivacidad = await apitexto.obtener(
          "Politica de privacidad"
        );

        if (responsePoliticaPrivacidad.length !== 0) {
          setPoliticaPrivacidad(responsePoliticaPrivacidad[0].Texto);
        }

        const responseCondicionesDeUso = await apitexto.obtener(
          "Condiciones de uso"
        );

        if (responseCondicionesDeUso.length !== 0) {
          setCondicionesDeUso(responseCondicionesDeUso[0].Texto);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return FalloLoginAutomatico === true ? (
    <div
      className="ingresar"
      style={{ overflow: "hidden", touchAction: "none" }}
    >
      <div>
        <Grid textalign="center" container style={{ padding: "5em 0em" }}>
          <Grid.Row>
            <Grid.Column>
              <Image src={imaLogo} className="logoIngresar" centered />
              <Header as="h3">{ingresar}</Header>
              <form
                size="large"
                textalign="center"
                onSubmit={formik.handleSubmit}
              >
                <Box
                  //component="form"
                  sx={{
                    "& > :not(style)": { m: 1, width: "25ch" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    id="email"
                    label={email}
                    placeholder={email}
                    variant="standard"
                    name="email"
                    type="email"
                    icon="mail"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                  <TextField
                    id="password"
                    label={contrasena}
                    placeholder={contrasena}
                    variant="standard"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <br></br>
                <Button
                  style={estiloBotones.Ingresar}
                  variant="contained"
                  type="submit"
                >
                  {ingresar}
                </Button>
                <br></br>
                <br></br>
                <label onClick={navigateToCambiarClave}>
                  {olvidaste_tu_contrasena}
                </label>
                <br></br>
                <br></br>
                <label onClick={navigateToCrearCuenta}>{crear_cuenta}</label>
                <br></br>
                <br></br>
                <label
                  as="a"
                  onClick={() => dispatchPP({ type: "OPEN_MODAL" })}
                >
                  {politica_de_privacidad}
                </label>
                <br></br>
                <label onClick={() => dispatchCS({ type: "OPEN_MODAL" })}>
                  {condiciones_del_servicio}
                </label>
                <br></br>
                <br></br>
                <label onClick={navigateToSeleccionarIdioma}>
                  {cambiar_idioma}
                </label>
              </form>
            </Grid.Column>
          </Grid.Row>
          <SinConexionAInternet></SinConexionAInternet>
        </Grid>
      </div>

      <Modal
        dimmer={dimmerPP}
        open={openPP}
        onClose={() => dispatchPP({ type: "CLOSE_MODAL" })}
      >
        <Menu style={BarraSuperior.Modal}>
          <Menu.Item>
            <h3 style={{ color: "white" }}>{politica_de_privacidad}</h3>
          </Menu.Item>
        </Menu>
        <Modal.Content>
          <div className="divTextos">{PoliticaPrivacidad}</div>
        </Modal.Content>
        <Modal.Actions style={{ margin: "0px 0px 13px 0px" }}>
          <Button
            style={estiloBotones.Cerrar}
            variant="contained"
            onClick={() => dispatchPP({ type: "CLOSE_MODAL" })}
          >
            {cerrar}
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        dimmer={dimmerCS}
        open={openCS}
        onClose={() => dispatchCS({ type: "CLOSE_MODAL" })}
      >
        <Menu style={BarraSuperior.Modal}>
          <Menu.Item>
            <h2 style={{ color: "white" }}>{condiciones_del_servicio}</h2>
          </Menu.Item>
        </Menu>
        <Modal.Content>
          <div className="divTextos">{CondicionesDeUso}</div>
        </Modal.Content>
        <Modal.Actions style={{ margin: "0px 0px 13px 0px" }}>
          <Button
            style={estiloBotones.Cerrar}
            onClick={() => dispatchCS({ type: "CLOSE_MODAL" })}
          >
            {cerrar}
          </Button>
        </Modal.Actions>
      </Modal>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  ) : (
    <div></div>
  );
}
